(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("EmergencySavingsCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["EmergencySavingsCalculator"] = factory();
	else
		root["EmergencySavingsCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition